import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoutingSettingsApiService {

  constructor(private http: HttpClient) {}

  private readonly routingSettingsUrl: string = 'configuration/routingRule';

  public getRoutingSettings(): Observable<any> {
    return this.http.get(this.routingSettingsUrl);
  }

  public editRoutingSettings(routingSettings): Observable<any> {
    return this.http.put(this.routingSettingsUrl, routingSettings);
  }
}
